import { keysToCamelCase } from "zod-to-camel-case";

import type {
  ReviewLessons,
  ReviewLessonsCamel,
} from "@/schema/internal/reviewLessons/reviewLessons.schema";

export const reviewLessonsFixture = ({
  overrides = {},
}: {
  overrides?: Partial<ReviewLessons>;
} = {}): ReviewLessons => ({
  lesson_id: 1,
  lesson_uid: "LESS-TE-0000001",
  partner_reviews: {
    video_status: "approved-oak",
    exit_quiz_status: "approved-oak",
    worksheet_status: "approved-oak",
    slide_deck_status: "approved-oak",
    lesson_info_status: "approved-oak",
    media_clips_status: "approved-not-used",
    starter_quiz_status: "approved-oak",
    worksheet_answers_status: "approved-oak",
    supplementary_resource_status: "approved-not-used",
    lesson_guide_status: "approved-not-used",
  },
  oak_reviews: {
    stage_1_oak_moderation_status: "not-started",
    stage_1_oak_subject_qa_status: "not-started",
    stage_2_oak_moderation_status: "not-started",
    stage_2_oak_subject_qa_status: "not-started",
    stage_1_oak_technical_qa_status: "not-started",
    stage_2_oak_technical_qa_status: "not-started",
    stage_1_creation_progress_status: "not-started",
    stage_2_creation_progress_status: "not-started",
  },
  oak_approval: [
    {
      date: "2025-01-01 00:00:00",
      ingest: {
        quiz: "ingest",
        video: "adding_captions",
        slidedeck: "ingest_started",
        worksheet: "ready_to_ingest",
        lesson_guide: "no_asset",
      },
      approver: {
        name: "Test Approver",
        email: "test.approver@thenational.academy",
        groups: "* Oak edu managers,All Subjects,All Users",
      },
    },
  ],
  status_lesson: "approved",
  status_slidedeck: "approved",
  status_worksheet: "",
  status_worksheet_answers: "",
  status_supplementary_resources: "",
  status_quiz: "",
  status_video: "",
  status_video_mux: "",
  status_video_rev: "",
  status_lesson_guide: "",
  status_media_clips: "",
  status_downloadable_files: "",
  release_uid: null,
  _cohort: "0",
  _state: "published",
  _deleted: false,
  _release_id: 5,
  created_at: "2025-01-01T00:00:00.000Z",
  updated_at: "2025-01-01T00:00:00.000Z",
  ...overrides,
});

export const reviewLessonsFixtureCamel = ({
  overrides = {},
}: {
  overrides?: Partial<ReviewLessonsCamel>;
} = {}): ReviewLessonsCamel => ({
  ...keysToCamelCase(reviewLessonsFixture()),
  ...overrides,
});
